(() => {
  const sourceLabel = 'Etsy buyer';
  const displayLabel = 'Verified Etsy Customer';
  const nameSelector = '.reputon-name';
  const widgetSelector = '.reputon-etsy-reviews-widget';
  const discoveryTimeoutMs = 15000;

  let discoveryObserver;
  let widgetObserver;
  let discoveryTimeout;

  const replaceExactLabel = (element) => {
    if (element instanceof Element && element.matches(nameSelector) && element.textContent === sourceLabel) {
      element.textContent = displayLabel;
    }
  };

  const replaceLabelsWithin = (root) => {
    if (!(root instanceof Element)) return;

    replaceExactLabel(root);
    root.querySelectorAll(nameSelector).forEach(replaceExactLabel);
  };

  const observeWidget = (widget) => {
    const observerRoot = widget.closest('.shopify-app-block') || widget;

    replaceLabelsWithin(observerRoot);

    widgetObserver?.disconnect();
    widgetObserver = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.type === 'characterData') {
          replaceExactLabel(mutation.target.parentElement);
          return;
        }

        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) replaceLabelsWithin(node);
        });
      });
    });
    widgetObserver.observe(observerRoot, { childList: true, subtree: true, characterData: true });

    discoveryObserver?.disconnect();
    window.clearTimeout(discoveryTimeout);
  };

  const findWidget = () => {
    const widget = document.querySelector(widgetSelector);
    if (widget) observeWidget(widget);
  };

  findWidget();

  if (!document.querySelector(widgetSelector)) {
    discoveryObserver = new MutationObserver(findWidget);
    discoveryObserver.observe(document.body, { childList: true, subtree: true });
    discoveryTimeout = window.setTimeout(() => discoveryObserver.disconnect(), discoveryTimeoutMs);
  }
})();
